export default __webpack_public_path__ + "static/img/vogue_scene_animated_0158.3a4aef7.webp";